import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';
import App from './App';
import './index.css';
import { InvitationsProvider } from './contexts/context';
import { AuthProvider } from './contexts/auth-context';

const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
if (posthogKey) {
  // EU project (data residency matches Supabase EU). In prod, events go first-party through the
  // Vercel /ingest rewrite (ad-blocker resilience); ui_host keeps toolbar/links on the EU app.
  // 'history_change' pageviews fit our no-router SPA - App.tsx pushState's a path per view.
  // Meeting content must never leak: content-bearing surfaces carry `ph-no-capture` (autocapture
  // ignores them), custom events carry ids/enums only, and session replay stays OFF.
  posthog.init(posthogKey, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://eu.i.posthog.com',
    ui_host: 'https://eu.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: 'history_change',
    disable_session_recording: true,
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {posthogKey ? (
      <PostHogProvider client={posthog}>
        <AuthProvider>
          <InvitationsProvider>
            <App />
          </InvitationsProvider>
        </AuthProvider>
      </PostHogProvider>
    ) : (
      <AuthProvider>
        <InvitationsProvider>
          <App />
        </InvitationsProvider>
      </AuthProvider>
    )}
  </React.StrictMode>
);

